import React from 'react';

const MusicCredits = () => {
  return (
    <div style={{ backgroundColor: "#ffffff", margin: '3rem'}}>
        <br />
      <h1 style={{ textAlign: 'center' }}>EMOTN Audio Credits</h1>
      <hr></hr>
        <ul >
        <h3 style={{ textDecoration: 'underline' }}>Classical</h3>
        <h5>Baroque</h5>
            <ul>
            <li>Concerto Brandeburghese no. 5 - I Movimento: Allegro</li>
                <li>J.S. Bach, Combattimento Consort Amsterdam, Jan Willem de Vriend – Brandenburg Concertos (2005)</li>
                <li><a href="https://www.youtube.com/watch?v=Cij9ftIKrIM">https://www.youtube.com/watch?v=Cij9ftIKrIM</a></li>
            </ul>
            <h5>Renaissance</h5>
            <ul>
            <li>Spem in alium (Arr. for oboe) : Spem in Alium - Thomas Tallis</li>
                <li>Huelgas-Ensemble · Paul Van Nevel – 40 Voices (2007)</li>
                <li><a href="https://www.youtube.com/watch?v=8uARuKnO44A">https://www.youtube.com/watch?v=8uARuKnO44A</a></li>
            </ul>
            <h5>Chamber</h5>
            <ul>
            <li>Serenade No. 10 in B-Flat Major, K. 361, "Gran Partita": IV. Adagio - Woflgang Amadeus Mozart</li>
                <li>Mozart, German Wind Soloists – Serenade No. 10 "Gran Partita" (1987)</li>
                <li><a href="https://www.youtube.com/watch?v=7Av_FJJwfTQ">https://www.youtube.com/watch?v=7Av_FJJwfTQ</a></li>
            </ul>
            <h5>Modern</h5>
            <ul>
            <li>In the Upper Room: Dance II - Michael Riesman · Philip Glass · Philip Glass Ensemble</li>
                <li>Philip Glass - DancePieces (1987)</li>
                <li>Copyright © – CBS Inc.</li>
                <li><a href="https://www.youtube.com/watch?v=bsS0m0tObb0&list=OLAK5uy_kddcjEp0O4ljkyawvAsagnm_WVRFvvDiE&index=3">https://www.youtube.com/watch?v=bsS0m0tObb0&list=OLAK5uy_kddcjEp0O4ljkyawvAsagnm_WVRFvvDiE&index=3</a></li>
            </ul>
      <br/>
      <h3 style={{ textDecoration: 'underline' }}>Nature</h3>
      <h5>Beach</h5>
            <ul>
            <li>10 Minutes Of Peaceful Beach Sounds For Meditation</li>
                <li>SFX Provided By AudioBlocks (https://www.audioblocks.com)</li>
                <li><a href="https://www.youtube.com/watch?v=tIZpNrr0uX8">https://www.youtube.com/watch?v=tIZpNrr0uX8</a></li>
            </ul>
        <h5>Thunderstorm</h5>
            <ul>
            <li>Thunderstorm in Norway - Stardust Vibes</li>
                <li>Thunderstorm Sounds for Sleep: Best Of </li>
                <li>℗ 2018 Stardust Vibes</li>
                <li><a href="https://www.youtube.com/watch?v=ko_c_oDCejA">https://www.youtube.com/watch?v=ko_c_oDCejA</a></li>
            </ul>
            <h5>Bird Songs</h5>
            <ul>
            <li>Wonderful Tropical Bird Sounds</li>
                <li>Peaceful Bird Sounds - Bird Sounds</li>
                <li>℗ 2016, Bird Sounds</li>
                <li><a href="https://www.youtube.com/watch?v=KyS1HHXl4SE ">https://www.youtube.com/watch?v=KyS1HHXl4SE</a></li>
            </ul>
            <h5>Campfire</h5>
            <ul>
            <li>Relaxing Campfire Sounds [ASMR] | 10 Minutes of Campfire Sounds</li>
                <li>All sounds compiled, adjusted and remixed by Daily Relaxation Sounds</li>
                <li><a href="https://www.youtube.com/watch?v=yUsn0gKNW-0">https://www.youtube.com/watch?v=yUsn0gKNW-0</a></li>
            </ul>
            <h5>Desert Night</h5>
            <ul>
            <li>Night time Nature Sounds - High Desert Nightlife - Crickets, Relaxing</li>
                <li>All sounds compiled, adjusted and remixed by Sounds Majestic</li>
                <li><a href="https://www.youtube.com/watch?v=r9Ii50ZiEYU">https://www.youtube.com/watch?v=r9Ii50ZiEYU</a></li>
            </ul>
            <br/>
      <h3 style={{ textDecoration: 'underline' }}>Instrumental</h3>
      <h5>Jazz</h5>
            <ul>
            <li>Jazz, Blues and Soft Rock Instrumental Mix #4 - 15 Minutes Royalty Free Tracks</li>
                <li><a href="https://www.youtube.com/watch?v=LsacFTdHHlM">https://www.youtube.com/watch?v=LsacFTdHHlM</a></li>
            </ul>
        <h5>Folk Guitar</h5>
            <ul>
            <li>Ghost of the Mountain - Justin Johnson</li>
                <li>Justin Johnson (14) – The Bootleg Series Vol. 3: Son Of A Witch (2021)</li>
                <li><a href="https://www.youtube.com/watch?v=OvqJGBopcwc">https://www.youtube.com/watch?v=OvqJGBopcwc</a></li>
            </ul>
        <h5>Lounge</h5>
            <ul>
            <li>no copyright music | free 11 mins cute background music (bgm, aesthetic, vlog)</li>
                <li><a href="https://www.youtube.com/watch?v=AnzHniWbCH8">https://www.youtube.com/watch?v=AnzHniWbCH8</a></li>
            </ul>
        <h5>Reggae</h5>
            <ul>
            <li>Riding West - The Aggrovators</li>
                <li>Bunny Striker Lee Presents - Aggrovators</li>
                <li>℗ 2011 Reggae Champs</li>
                <li><a href="https://www.youtube.com/watch?v=OvqJGBopcwc">https://www.youtube.com/watch?v=OvqJGBopcwc</a></li>
            </ul>
        <h5>Soft Electronic</h5>
            <ul>
            <li>Yves Tumor - Limerence [Extended]</li>
                <li>Various Artists – Mono No Aware</li>
                <li>© + ℗ 2017 PAN</li>
                <li><a href="https://www.youtube.com/watch?v=H-P1IcF137M">https://www.youtube.com/watch?v=H-P1IcF137M</a></li>
            </ul>
        <h5>Upbeat Synth</h5>
            <ul>
            <li>Melodic EDM Synth Trap Type Beat (prod. Remy Buster)</li>
                <li><a href="https://www.youtube.com/watch?v=dzG5jYKM-NM">https://www.youtube.com/watch?v=dzG5jYKM-NM</a></li>
            </ul>
        <br/>
      <h3 style={{ textDecoration: 'underline' }}>Ambient/Ethereal</h3>
        <h5>New Age</h5>
            <ul>
            <li>Harmonic Convergence - Steven Halpern</li>
                <li>Spectrum Suite - Music for Meditation & Inner Peace (1975)</li>
                <li>©1975, 1988 Open Channel Sound Company (BMI)</li>
                <li><a href="https://www.youtube.com/watch?v=zAUQL2OdDxA&list=PLYckswoZYBfugJFzA5dy9Y02NGNBVlcPP&index=19">https://www.youtube.com/watch?v=zAUQL2OdDxA&list=PLYckswoZYBfugJFzA5dy9Y02NGNBVlcPP&index=19</a></li>
            </ul>
        <h5>Zen</h5>
            <ul>
            <li>Oriental Flowers - Natural Aid</li>
                <li>Mother Nature Garden Zen Music</li>
                <li>℗ 2023 Exam Study Music International</li>
                <li><a href="https://www.youtube.com/watch?v=maiRoGB9FqE">https://www.youtube.com/watch?v=maiRoGB9FqE</a></li>
            </ul>
            <h5>Binaural Vibrations</h5>
            <ul>
            <li>Morning Motivator - Increase Motivation and Alertness - Beta Isochronic Tones - Focus Music</li>
                <li><a href="https://www.youtube.com/watch?v=G_zfnJvF8AY">https://www.youtube.com/watch?v=G_zfnJvF8AY</a></li>
            </ul>
            <h5>Minimalist</h5>
            <ul>
            <li>Rose Wreath Crown (For CW) - Kali Malone</li>
                <li>The Sacrificial Code</li>
                <li>℗ 2019 iDEAL Recordings</li>
                <li><a href="https://www.youtube.com/watch?v=3OtwCVcnoOQ">https://www.youtube.com/watch?v=3OtwCVcnoOQ</a></li>
            </ul>
            <h5>Drone</h5>
            <ul>
            <li>Cello Drone A · Musician's Practice Partner</li>
                <li>Cello Drones for Tuning and Improvisation</li>
                <li>℗ 2003 Marcia Sloane</li>
                <li><a href="https://www.youtube.com/watch?v=qpQ6c0NotCY">https://www.youtube.com/watch?v=qpQ6c0NotCY</a></li>
            </ul>
            <br />
            <h3 style={{ textDecoration: 'underline' }}>Background Noise</h3>
            <h5>Airplane</h5>
            <ul>
            <li>Calming Airplane Noise (with Crowd Sound)</li>
              <li>℗ 2023 Silgoa Sounds Effect</li>
                <li><a href="https://www.youtube.com/watch?v=_RmR6-_QXiI">https://www.youtube.com/watch?v=_RmR6-_QXiI</a></li>
            </ul>
            <h5>Train Cabin</h5>
            <ul>
            <li>Sleep Sounds - Train White Noise (Loopable)</li>
            <li>℗ 2022 Sleep Time Sound Records</li>
                <li><a href="https://www.youtube.com/watch?v=e3OE9RAe-qY">https://www.youtube.com/watch?v=e3OE9RAe-qY</a></li>
            </ul>
            <h5>Wind Chimes</h5>
            <ul>
            <li>Wind Chimes</li>
            <li>℗ 2014 TMSOFT, LLC</li>
                <li><a href="https://www.youtube.com/watch?v=9TR1355_E9k">https://www.youtube.com/watch?v=9TR1355_E9k</a></li>
            </ul>
            <h5>White Noise</h5>
            <ul>
            <li>10 Minutes Long Constant White Noise Timer</li>
            <li>℗ 2020 Sensory Deprivation Tank</li>
                <li><a href="https://www.youtube.com/watch?v=LZYK-HqFTV4">https://www.youtube.com/watch?v=LZYK-HqFTV4</a></li>
            </ul>
            <h5>Brown Noise</h5>
            <ul style={{ marginBottom: "5rem" }}>
            <li>Super Deep Brown Noise</li>
            <li>℗ 2023 SoundSfera Production</li>
                <li style={{ paddingBottom: "1rem" }}><a href="https://www.youtube.com/watch?v=QU85elrgOXo">https://www.youtube.com/watch?v=QU85elrgOXo</a></li>
            </ul>
        </ul>
    </div>
  );
};

export default MusicCredits;